// extracted by css-extract-rspack-plugin
export default {"root":"MaskContent_root__L5HBm","scroll":"MaskContent_scroll__CYwoa","disableScroll":"MaskContent_disableScroll__rV82T"};